import { DatePivotParams } from "../../entities/date_pivot_params";

export const defaultConfig: DatePivotParams = {
  dateHierarchy: "order_delivery_month",
  measure: "forecast",
  segments: [],
  minDate: null,
  maxDate: null,
  filters: [],
  postFilters: [],
};
